/* El visor del canal — abre los videos de Marisa DENTRO del sitio.
   Reglas que se respetan aquí:
   · el <iframe> se crea al hacer clic y se DESTRUYE al cerrar. Mientras nadie
     lo pida, la página no le manda una sola petición a YouTube; y al borrar el
     marco, el audio se calla de verdad (pausarlo no basta con un iframe).
   · el href real de cada enlace se queda intacto: sin JS, con clic de en medio,
     con ⌘/Ctrl o con "abrir en pestaña nueva", sigue yendo a YouTube.
   · el foco vuelve al renglón del que salió. Sin eso, cerrar con Esc deja al
     teclado al principio de la página. */
(function () {
  const visor  = document.getElementById('visor');
  const marco  = document.getElementById('visor-marco');
  const rotulo = document.getElementById('visor-tit');
  if (!visor || !marco) return;

  let volverA = null;

  function abrir(id, titulo, origen) {
    volverA = origen || null;
    rotulo.textContent = titulo || '';
    marco.innerHTML = '';

    const f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
            '?autoplay=1&rel=0&modestbranding=1';
    f.title = titulo || 'Video';
    f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    f.allowFullscreen = true;
    f.referrerPolicy = 'strict-origin-when-cross-origin';
    marco.appendChild(f);

    visor.hidden = false;
    document.documentElement.classList.add('visor-abierto');
    /* rAF: el diálogo tiene que estar pintado antes de que el foco tenga a dónde ir */
    requestAnimationFrame(() => visor.querySelector('.visor-x').focus());
  }

  function cerrar() {
    if (visor.hidden) return;
    visor.hidden = true;
    marco.innerHTML = '';            /* esto es lo que apaga el audio */
    document.documentElement.classList.remove('visor-abierto');
    if (volverA) { volverA.focus(); volverA = null; }
  }

  /* 🔴 El selector era `.videos a[data-yt]` — atado a UNA sección. La Bloom
     Library tiene su propio estante con la misma mecánica, así que el gancho
     pasa a ser el atributo y no el contenedor: cualquier enlace con `data-yt`
     abre en el visor, viva donde viva. */
  document.querySelectorAll('a[data-yt]').forEach(a => {
    a.addEventListener('click', e => {
      /* Se respeta cualquier gesto de "ábrelo aparte" */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      abrir(a.dataset.yt, a.dataset.tit, a);
    });
  });

  visor.addEventListener('click', e => {
    if (e.target.closest('[data-cerrar]') || e.target.closest('.visor-x')) cerrar();
  });

  addEventListener('keydown', e => {
    if (visor.hidden) return;
    if (e.key === 'Escape') { cerrar(); return; }
    /* Trampa de foco mínima: con el video abierto, el tabulador no se sale del
       diálogo. Aquí adentro solo hay un control enfocable —el de cerrar—, así
       que basta con devolverle el foco. */
    if (e.key === 'Tab') { e.preventDefault(); visor.querySelector('.visor-x').focus(); }
  });
})();
